@import (reference) '../../../../../constants/spacing.module';

.all-button {
  background: none;
  border-radius: @space-4;
  border: 1px solid var(--gray-637381);
  white-space: nowrap;
  cursor: pointer;
  background-color: var(--white);
}

.row-styled {
  width: 100%;
  flex-wrap: nowrap;
}

.input-styled {
  width: 100%;
  max-width: 300px;
}
